import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.function.name";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 引入Bpmn建模器对象
import BpmnModeler from "bpmn-js/lib/Modeler"; // 工具栏相关

import propertiesProviderModule from "bpmn-js-properties-panel/lib/provider/camunda";
import propertiesPanelModule from "bpmn-js-properties-panel";
import camundaModdleDescriptor from "camunda-bpmn-moddle/resources/camunda"; //汉化

import customTranslate from "./customTranslate";
import { Upload, Button } from 'element-ui';
export default {
  name: 'BpmnJS',
  components: {
    "el-upload": Upload,
    "el-button": Button
  },
  data: function data() {
    return {
      bpmnModeler: null,
      canvas: null,
      bpmnTemplate: "\n        <?xml version=\"1.0\" encoding=\"UTF-8\"?>\n        <definitions\n            xmlns=\"http://www.omg.org/spec/BPMN/20100524/MODEL\"\n            xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\"\n            xmlns:bpmndi=\"http://www.omg.org/spec/BPMN/20100524/DI\"\n            xmlns:omgdc=\"http://www.omg.org/spec/DD/20100524/DC\"\n            xmlns:camunda=\"http://camunda.org/schema/1.0/bpmn\"\n            xmlns:xsd=\"http://www.w3.org/2001/XMLSchema\"\n            xmlns:activiti=\"http://activiti.org/bpmn\"\n            id=\"m1577635100724\"\n            name=\"\"\n            targetNamespace=\"http://www.activiti.org/testm1577635100724\"\n          >\n          <process id=\"process\" processType=\"None\" isClosed=\"false\" isExecutable=\"true\">\n            <extensionElements>\n              <camunda:properties>\n                <camunda:property name=\"a\" value=\"1\" />\n              </camunda:properties>\n            </extensionElements>\n            <startEvent id=\"_2\" name=\"start\" />\n          </process>\n          <bpmndi:BPMNDiagram id=\"BPMNDiagram_leave\">\n            <bpmndi:BPMNPlane id=\"BPMNPlane_leave\" bpmnElement=\"leave\">\n              <bpmndi:BPMNShape id=\"BPMNShape__2\" bpmnElement=\"_2\">\n                <omgdc:Bounds x=\"144\" y=\"368\" width=\"32\" height=\"32\" />\n                <bpmndi:BPMNLabel>\n                  <omgdc:Bounds x=\"149\" y=\"400\" width=\"23\" height=\"14\" />\n                </bpmndi:BPMNLabel>\n              </bpmndi:BPMNShape>\n            </bpmndi:BPMNPlane>\n          </bpmndi:BPMNDiagram>\n        </definitions>\n    "
    };
  },
  methods: {
    newDiagram: function newDiagram() {
      this.createNewDiagram(this.bpmnTemplate);
    },
    downloadBpmn: function downloadBpmn() {
      var _this = this;

      this.bpmnModeler.saveXML({
        format: true
      }, function (err, xml) {
        if (!err) {
          // 获取文件名
          var name = "".concat(_this.getFilename(xml), ".bpmn"); // 将文件名以及数据交给下载方法

          _this.download({
            name: name,
            data: xml
          });
        }
      });
    },
    downloadSvg: function downloadSvg() {
      var _this2 = this;

      this.bpmnModeler.saveXML({
        format: true
      }, function (err, xml) {
        if (!err) {
          // 获取文件名
          var name = "".concat(_this2.getFilename(xml), ".svg"); // 从建模器画布中提取svg图形标签

          var context = "";

          var djsGroupAll = _this2.$refs.canvas.querySelectorAll(".djs-group");

          var _iterator = _createForOfIteratorHelper(djsGroupAll),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              context += item.innerHTML;
            } // 获取svg的基本数据，长宽高

          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          var viewport = _this2.$refs.canvas.querySelector(".viewport").getBBox(); // 将标签和数据拼接成一个完整正常的svg图形


          var svg = "\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n            width=\"".concat(viewport.width, "\"\n            height=\"").concat(viewport.height, "\"\n            viewBox=\"").concat(viewport.x, " ").concat(viewport.y, " ").concat(viewport.width, " ").concat(viewport.height, "\"\n            version=\"1.1\"\n            >\n            ").concat(context, "\n          </svg>\n        "); // 将文件名以及数据交给下载方法

          _this2.download({
            name: name,
            data: svg
          });
        }
      });
    },
    openBpmn: function openBpmn(file) {
      var _this3 = this;

      var reader = new FileReader(); // 读取File对象中的文本信息，编码格式为UTF-8

      reader.readAsText(file, "utf-8");

      reader.onload = function () {
        //读取完毕后将文本信息导入到Bpmn建模器
        _this3.createNewDiagram(reader.result);
      };

      return false;
    },
    getFilename: function getFilename(xml) {
      var start = xml.indexOf("process");
      var filename = xml.substr(start, xml.indexOf(">"));
      filename = filename.substr(filename.indexOf("id") + 4);
      filename = filename.substr(0, filename.indexOf('"'));
      return filename;
    },
    download: function download(_ref) {
      var _ref$name = _ref.name,
          name = _ref$name === void 0 ? "diagram.bpmn" : _ref$name,
          data = _ref.data;
      // 这里就获取到了之前设置的隐藏链接
      var downloadLink = this.$refs.downloadLink; // 把输就转换为URI，下载要用到的

      var encodedData = encodeURIComponent(data);

      if (data) {
        // 将数据给到链接
        downloadLink.href = "data:application/bpmn20-xml;charset=UTF-8," + encodedData; // 设置文件名

        downloadLink.download = name; // 触发点击事件开始下载

        downloadLink.click();
      }
    },
    init: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var customTranslateModule;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 获取画布 element
                this.canvas = this.$refs.canvas;
                customTranslateModule = {
                  translate: ["value", customTranslate]
                }; // 创建Bpmn对象

                this.bpmnModeler = new BpmnModeler({
                  // 设置bpmn的绘图容器为上门获取的画布 element
                  container: this.canvas,
                  // 加入工具栏支持
                  propertiesPanel: {
                    parent: "#js-properties-panel"
                  },
                  additionalModules: [propertiesProviderModule, propertiesPanelModule, //引入汉化
                  customTranslateModule],
                  moddleExtensions: {
                    camunda: camundaModdleDescriptor
                  }
                });
                _context.next = 5;
                return this.createNewDiagram(this.bpmnTemplate);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }(),
    createNewDiagram: function () {
      var _createNewDiagram = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(bpmn) {
        var _this4 = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // 将字符串转换成图显示出来;
                this.bpmnModeler.importXML(bpmn, function (err) {
                  if (err) {
                    _this4.$Message.error("打开模型出错,请确认该模型符合Bpmn2.0规范");
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createNewDiagram(_x) {
        return _createNewDiagram.apply(this, arguments);
      }

      return createNewDiagram;
    }()
  },
  mounted: function mounted() {
    this.init();
  }
};